export default "__VITE_ASSET__C7o64y2s__"